import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Reise} from './types';

@Component({
  selector: 'app-reise',
  templateUrl: './reise.component.html',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class ReiseComponent {
  @Input()
  reise: Reise;
}
